import React from "react";
import { FieldArrayWithId, UseFormReturn } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { FormCheck, FormInput } from "go-form";
import { FormDatePicker } from "go-form/components/FormDatePicker";
import {
	SupportAccessFormProps,
	SupportAccessPermissionConfig,
} from "../../../../../../../../services/Api/Organization/organizationTypes";
import { selectOrganization } from "../../../../../../../../services/organizations/selectors";

interface Props {
	index: number;
	field: FieldArrayWithId<SupportAccessFormProps, "applications", "key">;
	permission?: SupportAccessPermissionConfig;
	form: UseFormReturn<SupportAccessFormProps>;
}

const SupportAccessFormInputs = ({ index, field, permission, form }: Props) => {
	const {
		setValue,
		formState: { errors },
		register,
		control,
		clearErrors,
	} = form;
	const organization = useSelector(selectOrganization);
	const { t } = useTranslation();

	const handleChangeDate = (date: string) => {
		if (!date) return;
		setValue(`applications.${index}.support_access_to`, date);
	};

	return (
		<>
			<FormInput name={`applications.${index}.id`} errors={errors} register={register} type="hidden" />
			<FormDatePicker
				targetTimezone={organization.timezone}
				errors={errors}
				name={`applications.${index}.support_access_to`}
				onChangeDate={(date) => handleChangeDate(date)}
				control={control}
				defaultValue={field.support_access_to}
				label={t("modules.service_access.field.access_expires_at.title")}
			/>
			{errors?.applications?.[index]?.permissions && (
				<div className="invalid-feedback d-block">{t("constraints.should_pick_at_least_one_permission")}</div>
			)}
			{permission?.permissions.map((perm, permIndex) => {
				return (
					<FormCheck
						key={permIndex}
						onClick={() => clearErrors(`applications.${index}.permissions`)}
						value={perm}
						help={t(`enums.organization_access.${perm}.help_text`)}
						label={t(`enums.organization_access.${perm}.label`)}
						type="switch"
						name={`applications.${index}.permissions.${permIndex}`}
						errors={errors}
						register={register}
					/>
				);
			})}
		</>
	);
};

export default SupportAccessFormInputs;
